import { createContext } from 'react';

const kinesiologyContext = createContext();

export default kinesiologyContext;
